var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},[_c('li',[_c('p',[_vm._v(_vm._s(_vm.$t('notice.plan.sizeChange')))])]),_c('li',[_c('p',[_vm._v(_vm._s(_vm.$t('notice.plan.pickupMethodChange')))])]),_c('li',[_c('p',[_vm._v(_vm._s(_vm.$t('notice.plan.paymentMethodChange')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }